export function excludeModal(query = document.querySelectorAll('.modal')) {
    for (let modal of query) {
        document.body.append(modal);
    }
}
